import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import * as i2 from '@ngrx/store';
import { select } from '@ngrx/store';
import { getStepDetails } from 'visa-store';
import { Subject } from 'rxjs';
import * as i1 from '@angular/forms';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import * as i3 from 'app-services-library';
import * as i4 from '@angular/common';
import * as i5 from 'primeng/button';
import * as i6 from 'primeng/tooltip';
import * as i7 from '@angular/material/icon';
import * as i8 from 'primeng/inputswitch';
import { PrimengLibraryModule } from 'primeng-library';

class CustomQuestionsGroupService {
    constructor() { }
}
CustomQuestionsGroupService.ɵfac = function CustomQuestionsGroupService_Factory(t) { return new (t || CustomQuestionsGroupService)(); };
CustomQuestionsGroupService.ɵprov = i0.ɵɵdefineInjectable({ token: CustomQuestionsGroupService, factory: CustomQuestionsGroupService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomQuestionsGroupService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function CustomQuestionsGroupComponent_p_inputSwitch_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-inputSwitch", 5);
    i0.ɵɵlistener("onChange", function CustomQuestionsGroupComponent_p_inputSwitch_7_Template_p_inputSwitch_onChange_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.questionToggleFunc($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formControlName", ctx_r0.inputParams.name);
} }
const _c0 = function (a0, a1) { return { "btn-save": a0, "btn-cancel": a1 }; };
function CustomQuestionsGroupComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "button", 7);
    i0.ɵɵlistener("click", function CustomQuestionsGroupComponent_div_8_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.handleTristateChange(false); });
    i0.ɵɵelementStart(2, "span", 1);
    i0.ɵɵtext(3, "No");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 8);
    i0.ɵɵlistener("click", function CustomQuestionsGroupComponent_div_8_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r5); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.handleTristateChange(true); });
    i0.ɵɵelementStart(5, "span", 1);
    i0.ɵɵtext(6, "Yes");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 9);
    i0.ɵɵlistener("click", function CustomQuestionsGroupComponent_div_8_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r5); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.handleTristateChange(null); });
    i0.ɵɵelementStart(8, "span", 1);
    i0.ɵɵtext(9, "Unspecified");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c0, ctx_r1.state == false, ctx_r1.state != false))("disabled", ctx_r1.disabledFields);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(9, _c0, ctx_r1.state == true, ctx_r1.state != true))("disabled", ctx_r1.disabledFields);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(12, _c0, ctx_r1.state == null, ctx_r1.state != null))("disabled", ctx_r1.disabledFields);
} }
const _c1 = function (a0) { return { "width": a0 }; };
const _c2 = function (a0) { return { "mxWdth": a0 }; };
class CustomQuestionsGroupComponent {
    constructor(fb, store, appServicesLibraryService) {
        this.fb = fb;
        this.store = store;
        this.appServicesLibraryService = appServicesLibraryService;
        this.observableSubscription$ = new Subject();
        this.state = '';
        this.disabledFields = false;
    }
    ngOnInit() {
        var _a, _b, _c;
        this.userType = sessionStorage.getItem('userTypeRole');
        this.fieldId1 = this.uuid();
        this.fieldId2 = this.uuid();
        this.fieldId3 = this.uuid();
        this.group.addControl((_a = this.inputParams) === null || _a === void 0 ? void 0 : _a.name, this.fb.control((_b = this.inputParams) === null || _b === void 0 ? void 0 : _b.value));
        this.state = (_c = this.inputParams) === null || _c === void 0 ? void 0 : _c.value;
        if (this.inputData) {
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                var _a;
                this.inputData.stepStatusCode = (_a = data === null || data === void 0 ? void 0 : data.stepStatusDetails) === null || _a === void 0 ? void 0 : _a.stepStatusCode;
                setTimeout(() => {
                    this.toggleInputFields();
                }, 1000);
            });
        }
    }
    ngAfterViewInit() {
        this.appServicesLibraryService.reportLoaded();
    }
    toggleInputFields() {
        if (this.appServicesLibraryService.fieldToBeDisabled(this.inputData.stepStatusCode)) {
            this.group.disable();
            this.disabledFields = true;
        }
        else {
            this.group.enable();
            this.disabledFields = false;
        }
    }
    uuid() {
        const val1 = Date.now().toString(36);
        const val2 = Math.random().toString(36).substring(2);
        return val1 + val2;
    }
    questionToggleFunc(e) {
        this.inputParams.value = e.checked;
        this.group.controls[this.inputParams.name].setValue(e.checked);
    }
    handleTristateChange(val) {
        this.state = val;
        this.inputParams.value = val;
        this.group.controls[this.inputParams.name].setValue(val);
    }
}
CustomQuestionsGroupComponent.ɵfac = function CustomQuestionsGroupComponent_Factory(t) { return new (t || CustomQuestionsGroupComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i3.AppServicesLibraryService)); };
CustomQuestionsGroupComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CustomQuestionsGroupComponent, selectors: [["custom-questions-group"]], inputs: { formControlName: "formControlName", group: "group", inputParams: "inputParams", inputData: "inputData" }, decls: 9, vars: 11, consts: [[1, "custom-questions-group", 3, "ngClass", "formGroup"], [1, "common-bene-class-for-translation"], ["pButton", "", "type", "button", "pTooltip", "Select explicitly the required option", "tooltipPosition", "top", 1, "p-button-text", "p-button-rounded", 2, "color", "lightblue", "height", "1.457rem"], ["pTooltip", "Select explicitly the required option", "class", "questionToggle", 3, "formControlName", "onChange", 4, "ngIf"], ["class", "p-buttonset rightSwitch p-0 m-0", "style", "min-width: 280px !important;", 4, "ngIf"], ["pTooltip", "Select explicitly the required option", 1, "questionToggle", 3, "formControlName", "onChange"], [1, "p-buttonset", "rightSwitch", "p-0", "m-0", 2, "min-width", "280px !important"], ["pButton", "", "type", "button", "title", "No", 1, "btn-cancel", "btn-generic", 2, "font-size", "10px !important", "width", "25px", "padding", "0px !important", 3, "ngClass", "disabled", "click"], ["pButton", "", "type", "button", "title", "Yes", 1, "btn-cancel", "btn-generic", 2, "font-size", "10px !important", "width", "25px", "padding", "0px !important", 3, "ngClass", "disabled", "click"], ["pButton", "", "type", "button", "title", "Unspecified", 1, "btn-cancel", "btn-generic", 2, "font-size", "10px !important", "width", "60px", "padding", "0px !important", 3, "ngClass", "disabled", "click"]], template: function CustomQuestionsGroupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div");
        i0.ɵɵelementStart(2, "span", 1);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "button", 2);
        i0.ɵɵelementStart(5, "mat-icon");
        i0.ɵɵtext(6, "info");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, CustomQuestionsGroupComponent_p_inputSwitch_7_Template, 1, 1, "p-inputSwitch", 3);
        i0.ɵɵtemplate(8, CustomQuestionsGroupComponent_div_8_Template, 10, 15, "div", 4);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵstyleMap(i0.ɵɵpureFunction1(7, _c1, ctx.inputParams == null ? null : ctx.inputParams.style == null ? null : ctx.inputParams.style.width));
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c2, !(ctx.inputParams == null ? null : ctx.inputParams.isTwostate)))("formGroup", ctx.group);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1("", ctx.inputParams.label, " ");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.inputParams == null ? null : ctx.inputParams.isTwostate);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !(ctx.inputParams == null ? null : ctx.inputParams.isTwostate));
    } }, directives: [i4.NgClass, i1.NgControlStatusGroup, i1.FormGroupDirective, i5.ButtonDirective, i6.Tooltip, i7.MatIcon, i4.NgIf, i8.InputSwitch, i1.NgControlStatus, i1.FormControlName], styles: [".custom-questions-group[_ngcontent-%COMP%]{width:50%;display:flex;justify-content:space-between}.custom-questions-group[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-size:14px!important;display:flex;max-width:calc(100% - 60px)!important;float:left}.custom-questions-group[_ngcontent-%COMP%]   .questionToggle[_ngcontent-%COMP%]{width:8%}.custom-questions-group[_ngcontent-%COMP%]   .p-inputswitch[_ngcontent-%COMP%]{background:none!important}[_nghost-%COMP%]     .p-inputswitch .p-inputswitch-slider{height:22px}.switch-note[_ngcontent-%COMP%]{font-size:12px}.title.pr-1[_ngcontent-%COMP%]{font-weight:600}.mxWdth[_ngcontent-%COMP%]{width:auto!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomQuestionsGroupComponent, [{
        type: Component,
        args: [{
                selector: 'custom-questions-group',
                templateUrl: 'custom-questions-group.component.html',
                styleUrls: ['custom-questions-group.component.scss']
            }]
    }], function () { return [{ type: i1.FormBuilder }, { type: i2.Store }, { type: i3.AppServicesLibraryService }]; }, { formControlName: [{
            type: Input
        }], group: [{
            type: Input
        }], inputParams: [{
            type: Input
        }], inputData: [{
            type: Input
        }] }); })();

class CustomQuestionsGroupModule {
}
CustomQuestionsGroupModule.ɵfac = function CustomQuestionsGroupModule_Factory(t) { return new (t || CustomQuestionsGroupModule)(); };
CustomQuestionsGroupModule.ɵmod = i0.ɵɵdefineNgModule({ type: CustomQuestionsGroupModule });
CustomQuestionsGroupModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            ReactiveFormsModule,
            FormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CustomQuestionsGroupModule, { declarations: [CustomQuestionsGroupComponent], imports: [PrimengLibraryModule,
        ReactiveFormsModule,
        FormsModule], exports: [CustomQuestionsGroupComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomQuestionsGroupModule, [{
        type: NgModule,
        args: [{
                declarations: [CustomQuestionsGroupComponent],
                imports: [
                    PrimengLibraryModule,
                    ReactiveFormsModule,
                    FormsModule
                ],
                exports: [CustomQuestionsGroupComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of custom-questions-group
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CustomQuestionsGroupComponent, CustomQuestionsGroupModule, CustomQuestionsGroupService };
//# sourceMappingURL=custom-questions-group.js.map
